import React from "react";

import LabelHorizontal from "../labels/LabelHorizontal";
import ChannelReportSummaryRow from "./ChannelReportSummaryRow";
import { DividerBlackOnPrint } from "../styled";
import { HistoryReportGroupStackPrint } from "../styled/stack";

export default function ChannelReportSummary({ channel, data }) {
  return (
    <HistoryReportGroupStackPrint spacing={1} sx={{ mt: 2 }}>
      <LabelHorizontal label={channel} align="center" isbold />
      <DividerBlackOnPrint />
      <ChannelReportSummaryRow
        method="Online"
        finance={data.online_finance}
        amount={data.online_amount}
      />

      <ChannelReportSummaryRow
        method="Dinheiro"
        finance={data.money_finance}
        amount={data.money_amount}
      />

      <ChannelReportSummaryRow
        method="Maquininha"
        finance={data.card_finance}
        amount={data.card_amount}
      />

      {data.meal_ticket_amount > 0 && (
        <ChannelReportSummaryRow
          method="Vale Refeição"
          finance={data.meal_ticket_finance}
          amount={data.meal_ticket_amount}
        />
      )}

      {data.food_ticket_amount > 0 && (
        <ChannelReportSummaryRow
          method="Vale Alimentação"
          finance={data.food_ticket_finance}
          amount={data.food_ticket_amount}
        />
      )}

      {data.fuel_ticket_amount > 0 && (
        <ChannelReportSummaryRow
          method="Vale Combustível"
          finance={data.fuel_ticket_finance}
          amount={data.fuel_ticket_amount}
        />
      )}

      <ChannelReportSummaryRow
        method="Total"
        finance={data.finance}
        amount={data.orders}
        isBold
      />
    </HistoryReportGroupStackPrint>
  );
}
